var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',[_c('div',{staticClass:"grid"},[_c('Statistic'),_c('Notice')],1),_c('News')],1),_c('div',[_c('UserInfo'),_c('ApprovalCenter'),_c('div',{staticStyle:{"flex":"1","background-color":"#fff"}},[_c('Links')],1),_c('Website')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }